import api from './authService'
import { crearErrorAplicacionApi } from './apiError'

export interface Institucion {
  id?: number
  id_constitucion: number
  id_organizacion?: number | null
  nombre: string
  descripcion?: string
  tipo?: string
  tipo_organizacion?: string
  contacto_email?: string
  contacto_telefono?: string
  activo: boolean
  fecha_creacion?: string
  miembros_count?: number
  grupos_count?: number
  origen?: 'constitucion' | 'organizacion'
  es_empresa?: boolean
}

export interface InstitucionCrear {
  nombre: string
  descripcion?: string
  tipo?: string
  contacto_email?: string
  contacto_telefono?: string
  admin_inicial?: {
    nombre: string
    apellido?: string
    correo: string
    telefono?: string
    cargo?: string
    password: string
  }
}

export interface InstitucionActualizar {
  nombre?: string
  descripcion?: string
  tipo?: string
  contacto_email?: string
  contacto_telefono?: string
  activo?: boolean
}

export const institucionesService = {
  /**
   * Obtener lista de instituciones
   */
  async obtenerInstituciones(): Promise<Institucion[]> {
    try {
      const response = await api.get('/api/admin/constituciones')
      return response.data
    } catch (error: unknown) {
      console.error('Error al obtener instituciones:', error)
      throw crearErrorAplicacionApi(error, 'Error al obtener instituciones')
    }
  },

  /**
   * Crear nueva institución
   */
  async crearInstitucion(data: InstitucionCrear): Promise<Institucion> {
    try {
      const endpoint = data.tipo === 'empresa' ? '/api/admin/organizaciones' : '/api/admin/constituciones'
      const response = await api.post(endpoint, data)
      return response.data
    } catch (error: unknown) {
      console.error('Error al crear institución:', error)
      throw crearErrorAplicacionApi(error, 'Error al crear institución')
    }
  },

  /**
   * Actualizar institución existente
   */
  async actualizarInstitucion(entidad: Institucion, data: InstitucionActualizar): Promise<Institucion> {
    try {
      const endpoint = entidad.origen === 'organizacion'
        ? `/api/admin/organizaciones/${entidad.id_organizacion ?? entidad.id}`
        : `/api/admin/constituciones/${entidad.id_constitucion ?? entidad.id}`
      const response = await api.put(endpoint, data)
      return response.data
    } catch (error: unknown) {
      console.error('Error al actualizar institución:', error)
      throw crearErrorAplicacionApi(error, 'Error al actualizar institución')
    }
  },

  /**
   * Eliminar institución
   */
  async eliminarInstitucion(entidad: Institucion): Promise<void> {
    try {
      const endpoint = entidad.origen === 'organizacion'
        ? `/api/admin/organizaciones/${entidad.id_organizacion ?? entidad.id}`
        : `/api/admin/constituciones/${entidad.id_constitucion ?? entidad.id}`
      await api.delete(endpoint)
    } catch (error: unknown) {
      console.error('Error al eliminar institución:', error)
      throw crearErrorAplicacionApi(error, 'Error al eliminar institución')
    }
  }
}
